import React from "react";
import {Event} from "../../../../cp/components/Comet";
import {useEventContext} from "../EventContext";
import {usePlayerContext} from "../PlayerContext";

export default () => {
    const {eventDispatch} = useEventContext();
    const {setChangedBroadcastSession} = usePlayerContext();

    const onCreate = (data) => onUpdate(data);
    const onUpdate = (data) => eventDispatch((event) => {
        const newEvent = {...event};
        const streamIndex = newEvent.stream.findIndex(({id}) => id === data.streamId);
        if (-1 === streamIndex) {
            console.error('stream not found for update broadcastStreamSession');
            return event;
        }

        const sessionIndex = newEvent.stream[streamIndex].broadcastSession.findIndex(({id}) => id === data.id);
        if (-1 === sessionIndex) {
            newEvent.stream[streamIndex].broadcastSession.push(data);
        } else {
            newEvent.stream[streamIndex].broadcastSession[sessionIndex] = {
                ...newEvent.stream[streamIndex].broadcastSession[sessionIndex],
                ...data
            };
        }
        setTimeout(() => setChangedBroadcastSession(data), 100);

        return newEvent;
    });

    return (
        <>
            <Event event={'create:broadcast/stream/session'} handler={(data) => onCreate(data)} />
            <Event event={'update:broadcast/stream/session'} handler={(data) => onUpdate(data)} />
        </>
    );
}
